import { trackEvent } from '@otter-ai/telemetry';

export function trackAppInit() {
  trackEvent('APP_INIT', {
    AppVersion: `${process.env.NEXT_PUBLIC_APP_VERSION} - ${process.env.NEXT_PUBLIC_COMMIT_HEAD}`,
  });
}
